import React, { useState, useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useAuth0 } from '@ondeck/silkworm';

const SessionTimeout = () => {
  const [events] = useState(['click', 'load', 'scroll']);
  const { logout } = useAuth0();

  const { reset, getRemainingTime } = useIdleTimer({
    timeout: 1800000,
    crossTab: {
      emitOnAllTabs: true
    }
  });

  const handleReset = () => reset();

  const logoutUrl = `${window.env.REACT_APP_AUTH0_REDIRECT_URI}/login?message=timeout`;

  useEffect(() => {
    events.forEach(event => {
      window.addEventListener(event, handleReset);
    });

    setInterval(() => {
      if (getRemainingTime() === 0) {
        handleReset();
        logout(logoutUrl);
      }
    }, 1000);
  }, []);

  return <></>;
};

export default SessionTimeout;
